import axios from "axios";

export default class WebsiteSectionApi {
  constructor(apiPaths) {
    this.apiPaths = apiPaths;
  }

  createSection(section, afterSave) {
    axios.post(this.apiPaths.sections, {
      section: {
        section_type: section.sectionType,
        location: section.location,
        custom_field_slug: section.customFieldSlug,
        title: section.title,
        content: section.content,
        button_url: section.buttonUrl,
        button_text: section.buttonText,
        sale_or_lease: section.saleOrLease
      }
    }).then((response) => {
      const apiSection = response.data.section;
      if (apiSection && afterSave) {
        return afterSave(this.sectionFromApi(apiSection));
      }
    }).catch((error) => {
      // eslint-disable-next-line no-console
      console.error('API: Error creating section:', error);
    });
  }

  deleteSection(section, afterDelete) {
    axios.delete(section.path).then((response) => {
      if (response.data.success && afterDelete) {
        afterDelete();
      }
    });
  }

  updateSection(section, afterUpdate) {
    axios.put(section.path, {
      section: {
        section_type: section.sectionType,
        custom_field_slug: section.customFieldSlug,
        title: section.title,
        content: section.content,
        button_url: section.buttonUrl,
        button_text: section.buttonText
      }
    }).then((response) => {
      const updatedSection = response.data.section;
      if (updatedSection && afterUpdate) {
        afterUpdate(this.sectionFromApi(updatedSection));
      }
    });
  }

  reorderSections(sections, afterReorder) {
    axios.patch(
      this.apiPaths.sections,
      {
        parent: {
          sections_attributes: sections.map(section => ({
            id: section.id,
            sort_order: section.sortOrder,
            location: section.location
          }))
        }
      }
    ).then((response) => {
      const sections = response.data.sections;
      if (sections && afterReorder) {
        afterReorder(
          sections.map(section => this.sectionFromApi(section))
            .sort((s1, s2) => s1.sortOrder - s2.sortOrder)
        );
      }
    });
  }

  sectionFromApi(apiSection) {
    return {
      id: apiSection.id,
      customFieldSlug: apiSection.custom_field_slug,
      icon: apiSection.icon,
      label: apiSection.label,
      location: apiSection.location,
      path: apiSection.path,
      saleOrLease: apiSection.sale_or_lease,
      sectionType: apiSection.section_type,
      sortOrder: apiSection.sort_order,
      title: apiSection.title,
      content: apiSection.content,
      buttonUrl: apiSection.button_url,
      buttonText: apiSection.button_text
    };
  }
}
